import { KeyValuePair, Land, Planung } from '@/modules/ewerp/models/PlanungModels';

export type State = {
  planung: Array<Planung>;
  produktionsauftraege: Array<Planung>;
  palettenProStunde: Array<KeyValuePair>;
  laender: Array<Land>;
};

export const state: State = {
  planung:
    sessionStorage.getItem('planung') != null && sessionStorage.getItem('planung') !== undefined ? JSON.parse(sessionStorage.planung) : new Array<Planung>(),
  produktionsauftraege:
    sessionStorage.getItem('produktionsauftraege') != null && sessionStorage.getItem('produktionsauftraege') !== undefined
      ? JSON.parse(sessionStorage.produktionsauftraege)
      : new Array<Planung>(),
  palettenProStunde:
    sessionStorage.getItem('palettenProStunde') != null && sessionStorage.getItem('palettenProStunde') !== undefined
      ? JSON.parse(sessionStorage.palettenProStunde)
      : new Array<KeyValuePair>(),
  laender:
    sessionStorage.getItem('laender') != null && sessionStorage.getItem('laender') !== undefined ? JSON.parse(sessionStorage.laender) : new Array<Land>(),
};
